import { Typography as MuiTypography } from "@mui/material";


export const Typography = (props: any) => {
    return<MuiTypography {...props}>
        </MuiTypography>
  };
